module.exports = "/* .mat-column-product_name {\r\n    min-width: 100px;\r\n}\r\n\r\n.mat-column-actions {\r\n    min-width: 50px;\r\n} */"